let $ = jQuery;

module.exports = {
  attach: function (context, settings) {

    var $menu = $(context).find('.dashboard__menu');
    var $trigger = $(context).find('.dashboard__trigger');

    $trigger.on('click',function() {
      $menu.toggleClass('dashboard__menu--hidden');
      $trigger.toggleClass('dashboard__trigger--hidden');
    });

    $menu.find('.close').on('click',function() {
      $menu.addClass('dashboard__menu--hidden');
      $trigger.removeClass('dashboard__trigger--hidden');
    });

  }
};
